import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart, CART_URL } from '../lib/metaPixel';
export function FinalCTASection() {
  return <section className="py-24 md:py-40 bg-gradient-to-b from-zinc-900 to-black relative overflow-hidden pt-[10px] pb-[10px]" data-id="element-91">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-orange-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-92"></div>

      <div className="container mx-auto px-5 sm:px-6 md:px-8 relative z-10" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto text-center mt-[0px] mb-[0px] space-y-[24px]" data-id="element-94">
          <h2 className="text-5xl md:text-6xl lg:text-[5rem] font-display text-white mb-10 uppercase tracking-tight leading-[0.95]" data-id="element-95">
            Dejá de empezar de cero todos los lunes.{' '}
            <br className="hidden md:block" data-id="element-96" />
            <span className="text-orange-500" data-id="element-97">
              Empezá hoy con un sistema claro.
            </span>
          </h2>

          <div className="space-y-6 mb-16 text-xl md:text-2xl text-zinc-300 leading-relaxed max-w-3xl mx-auto" data-id="element-98">
            <p className="mt-[-1px] mb-[-1px]" data-id="element-99">
              Durante los próximos 90 días podés seguir igual, probando dietas
              al azar, improvisando comidas y sintiendo que no avanzás.
            </p>
            <p className="text-white font-bold bg-zinc-800/50 p-6 rounded-2xl border border-zinc-700" data-id="element-100">
              O podés empezar con un plan simple, medible y diseñado para
              ayudarte a bajar grasa, reducir la panza y recuperar confianza sin
              pasar hambre ni vivir en el gimnasio.
            </p>
          </div>

          <a href={CART_URL} onClick={() => trackAddToCart({
          value: 7.99,
          currency: 'USD',
          content_name: 'Plan Anti Panza'
        })} className="inline-block w-full md:w-auto bg-orange-500 hover:bg-orange-400 text-white font-black text-xl md:text-2xl px-16 py-8 rounded-2xl uppercase tracking-wide transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_50px_rgba(249,115,22,0.4)] mt-[-50px] mb-[-50px]" data-id="element-101">
            Acceder ahora al Plan Anti Panza con 50% OFF
          </a>

          <p className="text-zinc-400 text-sm md:text-base font-medium uppercase tracking-widest mt-[20px] mb-[20px]" data-id="element-102">
            Incluye ebook completo + 6 bonos digitales + acceso inmediato +
            garantía de 7 días.
          </p>
        </motion.div>
      </div>
    </section>;
}